export default class RequestMaker {
  constructor(endpoint) {
    this.endpoint = endpoint;
  }
  getHeaders() {
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    return headers;
  }
  getContext(contextResolver) {
    const context = typeof contextResolver === 'function' ? contextResolver() : contextResolver;
    if (typeof (context === null || context === void 0 ? void 0 : context.useCase) !== 'string' || (context === null || context === void 0 ? void 0 : context.useCase.trim().length) === 0) {
      throw new Error('useCase is required');
    }
    return context;
  }
}